<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_2719_18103)">
            <path
                d="M12.5574 9.5L4.65039 8V19.0835C4.65039 19.5897 5.03209 20 5.50295 20H19.1467C19.6175 20 19.9992 19.5897 19.9992 19.0835V15L12.5574 9.5Z"
                fill="#185C37"
            />
            <path
                d="M12.5574 0H5.50295C5.03209 0 4.65039 0.410329 4.65039 0.916498V5L12.5574 10L16.7434 11.5L19.9992 10V5L12.5574 0Z"
                fill="#21A366"
            />
            <path d="M4.65039 5H12.5574V10H4.65039V5Z" fill="#107C41" />
            <path
                opacity="0.1"
                d="M10.3095 4H4.65039V16.5H10.3095C10.7797 16.4984 11.1605 16.089 11.162 15.5835V4.9165C11.1605 4.41101 10.7797 4.00164 10.3095 4Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M9.84435 4.5H4.65039V17H9.84435C10.3146 16.9984 10.6954 16.589 10.6969 16.0835V5.4165C10.6954 4.91101 10.3146 4.50164 9.84435 4.5Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M9.84435 4.5H4.65039V16H9.84435C10.3146 15.9984 10.6954 15.589 10.6969 15.0835V5.4165C10.6954 4.91101 10.3146 4.50164 9.84435 4.5Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M9.37923 4.5H4.65039V16H9.37923C9.84945 15.9984 10.2303 15.589 10.2318 15.0835V5.4165C10.2303 4.91101 9.84945 4.50164 9.37923 4.5Z"
                fill="black"
            />
            <path
                d="M0.852556 4.5H9.37999C9.85085 4.5 10.2325 4.91033 10.2325 5.4165V14.5835C10.2325 15.0897 9.85085 15.5 9.37999 15.5H0.852556C0.381701 15.5 0 15.0897 0 14.5835V5.4165C0 4.91033 0.381701 4.5 0.852556 4.5Z"
                fill="url(#paint0_linear_2719_18103)"
            />
            <path
                d="M2.64062 12.979L4.43411 9.99151L2.79086 7.02051H4.11272L5.00946 8.92051C5.09226 9.10101 5.149 9.23501 5.1797 9.3235H5.19132C5.25024 9.1795 5.31225 9.03967 5.37737 8.904L6.33597 7.02151H7.54946L5.86434 9.97502L7.59226 12.979H6.30109L5.26528 10.8935C5.21649 10.8048 5.17509 10.7116 5.14156 10.615H5.12622C5.09587 10.7096 5.05561 10.8002 5.00621 10.885L3.9397 12.979H2.64062Z"
                fill="white"
            />
            <path
                d="M19.1479 0H12.5586V5H20.0005V0.916498C20.0005 0.410329 19.6188 0 19.1479 0Z"
                fill="#33C481"
            />
            <path d="M12.5586 10H20.0005V15H12.5586V10Z" fill="#107C41" />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_2719_18103"
                x1="1.7776"
                y1="3.78387"
                x2="9.20512"
                y2="15.7505"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#18884F" />
                <stop offset="0.5" stop-color="#117E43" />
                <stop offset="1" stop-color="#0B6631" />
            </linearGradient>
            <clipPath id="clip0_2719_18103">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {}
</script>
